export default __webpack_public_path__ + "static/screeny-150-storm-1-d19940b0cd095414afcfb9078e28f65b.jpg";